// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap {
  display: flex;
  flex-direction: column;
}
.image.wrap img {
  margin: 0rem;
}
.image.rotate img {
  width: 250px;
  animation: rotate-layover 120s infinite linear;
}
.wrap p {
  text-align: justify;
  font-size: 1.6rem;
  line-height: 2.5rem;
}
.wrap.content h5 {
  font-size: 2.4rem;
  padding: 0rem;
  margin-bottom: 1rem;
  text-align: center;
}

.wrap.content p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0rem;
}
.wrap.content h4 {
  padding: 0rem;
  margin-bottom: 1rem;
  text-align: center;
  font-size: 3rem;
}

.wrap.content {
  display: unset;
}
@media (min-width: 500px) {
  .wrap.content p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1vw 2rem;
  }
  .wrap {
    display: inline-block;
    flex-direction: unset;
  }
  .image.wrap {
    float: left;
    margin: 1rem;
    width: 40%;
    max-width: 300px;
  }
  .image.wrap.large {
    width: 50%;
    max-width: 400px;
  }
  .image.wrap.reverse {
    float: right;
  }
  .wrap.content h4 {
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 3vw;
  }
  .wrap.content h5 {
    font-size: 2.4vw;
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .wrap.content h6 {
    font-size: 1.8vw;
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
  }
}
@media (min-width: 1000px) {
  .wrap {
    display: inline-block;
    flex-direction: unset;
  }
  .image.wrap {
    float: left;
    margin: 1rem;
    padding: 0rem 1.5rem;
    width: 30%;
    max-width: 300px;
  }

  .image.wrap.reverse {
    float: right;
    padding: 0rem 1.5rem;
    width: 30%;
    max-width: 300px;
  }
  .wrap.content h4 {
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 3rem;
  }
  .wrap.content h5 {
    font-size: 2.4rem;
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .wrap.content h6 {
    font-size: 1.8rem;
    padding: 0rem;
    margin-bottom: 1rem;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GenericPage/PageRows/WrapText/wrapText.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE;;;;;;;IAOE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n}\n.image.wrap img {\n  margin: 0rem;\n}\n.image.rotate img {\n  width: 250px;\n  animation: rotate-layover 120s infinite linear;\n}\n.wrap p {\n  text-align: justify;\n  font-size: 1.6rem;\n  line-height: 2.5rem;\n}\n.wrap.content h5 {\n  font-size: 2.4rem;\n  padding: 0rem;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.wrap.content p,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0rem;\n}\n.wrap.content h4 {\n  padding: 0rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-size: 3rem;\n}\n\n.wrap.content {\n  display: unset;\n}\n@media (min-width: 500px) {\n  .wrap.content p,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 1vw 2rem;\n  }\n  .wrap {\n    display: inline-block;\n    flex-direction: unset;\n  }\n  .image.wrap {\n    float: left;\n    margin: 1rem;\n    width: 40%;\n    max-width: 300px;\n  }\n  .image.wrap.large {\n    width: 50%;\n    max-width: 400px;\n  }\n  .image.wrap.reverse {\n    float: right;\n  }\n  .wrap.content h4 {\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n    font-size: 3vw;\n  }\n  .wrap.content h5 {\n    font-size: 2.4vw;\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n  .wrap.content h6 {\n    font-size: 1.8vw;\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n}\n@media (min-width: 1000px) {\n  .wrap {\n    display: inline-block;\n    flex-direction: unset;\n  }\n  .image.wrap {\n    float: left;\n    margin: 1rem;\n    padding: 0rem 1.5rem;\n    width: 30%;\n    max-width: 300px;\n  }\n\n  .image.wrap.reverse {\n    float: right;\n    padding: 0rem 1.5rem;\n    width: 30%;\n    max-width: 300px;\n  }\n  .wrap.content h4 {\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n    font-size: 3rem;\n  }\n  .wrap.content h5 {\n    font-size: 2.4rem;\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n  .wrap.content h6 {\n    font-size: 1.8rem;\n    padding: 0rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
